import { S3 } from '@aws-sdk/client-s3';

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

const fetchHyhoContent = ({ config, uri, reporter, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { bucketName, bucketLocation, awsAccessKeyId, awsAccessKey } = config;
    const logger = reporter !== null && reporter !== void 0 ? reporter : console;
    const s3params = {
        Bucket: bucketName,
        Key: uri,
    };
    const s3 = new S3({
        region: bucketLocation,
        credentials: {
            accessKeyId: awsAccessKeyId,
            secretAccessKey: awsAccessKey,
        },
    });
    try {
        const { Body } = yield s3.getObject(s3params);
        const { Content__c: body, ValidFrom__c: validFrom, ValidTo__c: validTo, Document_Version_ID__c: versionId, DocType__c: documentType, } = JSON.parse((yield (Body === null || Body === void 0 ? void 0 : Body.transformToString('utf-8'))) || '{}');
        return {
            body,
            validFrom,
            validTo,
            versionId,
            documentType,
        };
    }
    catch (err) {
        logger.error('Error on fetch hyho content', err);
        return null;
    }
});

const LdsHyhoContentFetcher = {
    hyho: (_a) => __awaiter(void 0, void 0, void 0, function* () {
        var args = __rest(_a, []);
        return fetchHyhoContent(Object.assign({}, args));
    }),
};

export { LdsHyhoContentFetcher };
